module.exports = __webpack_public_path__ + "static/media/greenhouse2Step11-1.1729e13a.jpg";